// Spanish for the camera page and its drawers (23 Oct 2026).
export const CAMERA: Record<string, string> = {
  "Analysis area": "Zona de análisis",
  "Analysis area configured": "Zona de análisis configurada",
  "Only activity inside the configured area is used for future visual analysis.": "Solo se usa la actividad dentro de la zona configurada para los próximos análisis visuales.",
  "Full image is used for analysis (click to set an analysis area)": "Se analiza la imagen completa (haz clic para definir una zona de análisis)",
  "initial": "inicial",
  "phase change": "cambio de fase",
  "weekly refresh": "actualización semanal",
  "manual": "manual",
  "analysis area changed": "zona de análisis cambiada",
  "manual edit": "edición manual",
  "Scene baseline": "Escena de referencia",
  "stale > 7 days": "antigua > 7 días",
  "No baseline yet — will be generated on first analysis (click to open)": "Aún no hay escena de referencia: se creará en el primer análisis (haz clic para abrir)",
  "Today's analyses": "Análisis de hoy",
  "No analyses yet — the analyzer runs at :00 :15 :30 :45.": "Aún no hay análisis: se analiza a las :00, :15, :30 y :45.",
  "1 analysis": "1 análisis",
  "{n} analyses": "{n} análisis",
  "high activity in this hour": "mucha actividad en esta hora",
  "high activity": "mucha actividad",
  "Recent events": "Eventos recientes",
  "No events for this camera": "No hay eventos de esta cámara",
  "1 capture": "1 captura",
  "{n} captures": "{n} capturas",
  "Camera notes": "Notas de la cámara",
  "No notes yet.": "Aún no hay notas.",
  "Camera settings": "Ajustes de la cámara",
  "Room name": "Nombre de la estancia",
  "The name of the space this camera shows. It appears under the camera and in the Site update text (for example “Ground floor” or “Salon”).": "El nombre del espacio que muestra esta cámara. Aparece bajo la cámara y en el texto de la actualización de obra (por ejemplo «Planta baja» o «Salón»).",
  "Save": "Guardar",
  "Saved": "Guardado",
  "Could not save — please try again.": "No se ha podido guardar. Inténtalo de nuevo.",
  "The Site update uses the new name from its next refresh.": "La actualización de obra usará el nuevo nombre a partir de su próxima actualización.",
  "Analysis hours": "Horario de análisis",
  "Loading…": "Cargando…",
  "Automatic AI analysis runs during these hours, at the frequency below. Photos continue to be collected outside these hours.": "El análisis automático con IA funciona en este horario, con la frecuencia indicada abajo. Fuera de este horario se siguen recogiendo fotos.",
  "Outside this window, automatic visual assessment is paused — captured photos wait and are not analyzed until the window opens again.": "Fuera de este horario el análisis visual automático se pausa: las fotos esperan y no se analizan hasta que vuelva a empezar el horario.",
  "Start": "Inicio",
  "End": "Fin",
  "Frequency": "Frecuencia",
  "Once an hour (at :01, best photo of the hour)": "Una vez por hora (a las :01, la mejor foto de la hora)",
  "Twice an hour (at :31 and :01, best photo of each half hour)": "Dos veces por hora (a las :31 y :01, la mejor foto de cada media hora)",
  "Twice an hour costs about $15–20 more per camera per month.": "Dos veces por hora cuesta unos 15–20 $ más por cámara al mes.",
  "Cancel": "Cancelar",
  "Changes apply going forward only — nothing already captured is reanalyzed or reprocessed.": "Los cambios solo se aplican de aquí en adelante: no se vuelve a analizar nada de lo ya capturado.",
  "Analysis & framing": "Análisis y encuadre",
  "Framing": "Encuadre",
  "Notes": "Notas",
  "No notes recorded for this camera.": "No hay notas para esta cámara.",
  "Camera ID": "ID de la cámara",
  "Uploaded {time}": "Subida a las {time}",
  "A newer photo is available — click to view latest": "Hay una foto más reciente: haz clic para ver la última",
  "No image available": "No hay imagen disponible",
  "Open enlarged view": "Ver en grande",
  "{zone} camera snapshot": "Foto de la cámara {zone}",
  "Captured {time}": "Capturada {time}",
  "No image yet": "Aún no hay imagen",
  "Settings": "Ajustes",
  "Refresh": "Actualizar",
  "{zone} camera snapshot, enlarged": "Foto de la cámara {zone}, ampliada",
  "Previous camera: {zone}": "Cámara anterior: {zone}",
  "Next camera: {zone}": "Cámara siguiente: {zone}",
  "Online": "En línea",
  "Offline": "Sin conexión",
  "AI analysis is active now": "El análisis con IA está activo ahora",
  "AI analysis is paused outside scheduled hours": "El análisis con IA se pausa fuera del horario programado",
  "Analysis active": "Análisis activo",
  "Analysis paused": "Análisis en pausa",
  "Date": "Fecha",
  "Previous photo": "Foto anterior",
  "Prev": "Anterior",
  "Next photo": "Foto siguiente",
  "Next": "Siguiente",
  "Latest": "Última",
  "No photos for this day.": "No hay fotos de este día.",
  "Show earlier photos ({n} more)": "Ver fotos anteriores ({n} más)",
  "Photo thumbnails": "Miniaturas de fotos",
  "Not reviewed": "Sin revisar",
  "This camera's most recent photo": "La foto más reciente de esta cámara",
  "Newest": "Última",
  "Capture at {time}": "Captura de las {time}",
  "Enlarged view: {alt}": "Vista ampliada: {alt}",
  "Zoom out": "Alejar",
  "Zoom in": "Acercar",
  "Close": "Cerrar",
  "Close enlarged view": "Cerrar vista ampliada",
  "This exact photo hasn't been reviewed yet. Only one photo per camera is reviewed each hour, and this hour's hasn't been chosen yet.": "Esta foto aún no se ha revisado. Solo se revisa una foto por cámara cada hora, y la de esta hora aún no se ha elegido.",
  "This photo was taken outside this camera's scheduled review hours.": "Esta foto se tomó fuera del horario de revisión de esta cámara.",
  "A different photo from this same hour was reviewed instead of this one.": "Se revisó otra foto de esta misma hora en lugar de esta.",
  "A description for this photo isn't available right now.": "Ahora mismo no hay descripción para esta foto.",
  "No description is available for this photo.": "No hay descripción para esta foto.",
  "What Zonoo sees": "Lo que ve Zonoo",
  "No photo selected.": "No hay ninguna foto seleccionada.",
  "Reviewed photo": "Foto revisada",
  "From the photo captured {time}": "De la foto capturada {time}",
  "Photo captured {time}": "Foto capturada {time}",
  "No summary recorded for this photo.": "No hay resumen para esta foto.",
  "High relevance": "Relevancia alta",
  "No summary recorded for this cycle.": "No hay resumen para este ciclo.",
  "Weather: {weather}": "Tiempo: {weather}",
  "Personnel: {n}": "Personas: {n}",
  "Event detail": "Detalle del evento",
  "Loading event…": "Cargando evento…",
  "Event {id}": "Evento {id}",
  "No image": "Sin imagen",
  "Previous event": "Evento anterior",
  "Next event": "Evento siguiente",
  "Daily brief evidence": "Pruebas del resumen diario",
  "Weekly summary evidence": "Pruebas del resumen semanal",
  "Loading evidence…": "Cargando pruebas…",
  "No camera image is available to show for this period.": "No hay ninguna imagen de cámara para este periodo.",
  "Comparing images…": "Comparando imágenes…",
  "Image comparison is temporarily unavailable.": "La comparación de imágenes no está disponible en este momento.",
  "Retrying…": "Reintentando…",
  "Retry": "Reintentar",
  "Visual comparison": "Comparación visual",
  "No image available for this position.": "No hay imagen para esta posición.",
  "Yes": "Sí",
  "No": "No",
  "Not enough evidence": "No hay pruebas suficientes",
  "Does this comparison support the summary?": "¿Esta comparación respalda el resumen?",
  "Loading baseline…": "Cargando escena de referencia…",
  "Regeneration failed": "No se ha podido regenerar",
  "Saving the edit failed": "No se ha podido guardar el cambio",
  "baseline": "referencia",
  "Edit": "Editar",
  "Queueing…": "En cola…",
  "Regenerate baseline": "Regenerar referencia",
  "Manual regen queued — jumps the queue": "Regeneración manual en cola: pasa por delante",
  "Baseline description": "Descripción de la escena de referencia",
  "Saving…": "Guardando…",
  "Phase at generation:": "Fase al generarla:",
  "No baseline yet. A baseline will be generated automatically on this camera's first batch (bootstrap mode). You can also trigger it manually with the button above.": "Aún no hay escena de referencia. Se creará automáticamente con el primer lote de esta cámara (modo de arranque). También puedes generarla a mano con el botón de arriba.",
  "batch": "lote",
  "Analysis detail": "Detalle del análisis",
  "Loading analysis…": "Cargando análisis…",
  "Anchor frame this hour": "Foto de referencia de esta hora",
  "Anchor frames this hour": "Fotos de referencia de esta hora",
  "Activity": "Actividad",
  "Personnel": "Personas",
  "{n} people": "{n} personas",
  "Weather": "Tiempo",
  "Relevance": "Relevancia",
  "Event #{id}": "Evento n.º {id}",
  "Safety:": "Seguridad:",
  "Back": "Volver",
  "1 photo analysed": "1 foto analizada",
  "{n} photos analysed": "{n} fotos analizadas",
  "Set analysis area": "Definir zona de análisis",
  "Only activity inside this area will be used for future visual analysis. The complete image will still be stored.": "Solo se usará la actividad dentro de esta zona para los próximos análisis visuales. La imagen completa se seguirá guardando.",
  "Analysis area configured.": "Zona de análisis configurada.",
  "Analysis area removed — using the full image for analysis again.": "Zona de análisis eliminada: se vuelve a analizar la imagen completa.",
  "Could not save.": "No se ha podido guardar.",
  "Could not remove.": "No se ha podido eliminar.",
  "Removing…": "Eliminando…",
  "Remove analysis area": "Eliminar zona de análisis",
  "Latest complete camera image, used to draw the analysis area": "Última imagen completa de la cámara, para dibujar la zona de análisis",
  "Click and drag on the image to draw the analysis area": "Haz clic y arrastra sobre la imagen para dibujar la zona de análisis",
  "Adjust {context} framing": "Ajustar el encuadre de {context}",
  "Drag the photo to move it, use the slider to zoom in or out. This only changes how the photo is framed here — the original image is never altered.": "Arrastra la foto para moverla y usa el control para acercar o alejar. Solo cambia cómo se encuadra la foto aquí: la imagen original no se modifica nunca.",
  "Preview": "Vista previa",
  "Preview of the adjusted framing": "Vista previa del encuadre ajustado",
  "Loading photo…": "Cargando foto…",
  "Framing saved.": "Encuadre guardado.",
  "Framing reset to the default.": "Encuadre restablecido al predeterminado.",
  "Could not reset.": "No se ha podido restablecer.",
  "Resetting…": "Restableciendo…",
  "Reset to default": "Restablecer",
  "Latest complete camera image, used to adjust the framing": "Última imagen completa de la cámara, para ajustar el encuadre",
  "Zoom": "Zoom",
}
